"use client"

import styled from "@emotion/styled"
import { GetPageByRouteQuery } from "apollo"
import { BlockRenderer, CustomBreadcrumbs } from "ui"
import Container from "ui/Container"
import { getBreadCrumbs, transformProperties } from "utils"

type Props = {
  data: GetPageByRouteQuery
  locale: string
}

const StyledBreadcrumbsContainer = styled.div``

const StyledDiv = styled.div`
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
  padding-top: 16px;
  padding-bottom: 64px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-top: 32px;
  }
`

const StyledContentWrapper = styled.div`
  padding-top: 16px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-top: 32px;
  }
  h3 {
    padding-top: 14px;
    ${({ theme }) => theme.breakpoints.up("md")} {
      padding-top: 28px;
    }
  }
`

const components = {
  mainTitleBlock: () => import("./MainTitle"),
  titleTextAndMediaBlock: () => import("./TitleTextAndMedia"),
}

const Terms = ({ data, locale }: Props) => {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)
  return (
    <Container paddingMobile>
      <StyledDiv>
        <StyledBreadcrumbsContainer>
          <CustomBreadcrumbs breadcrumbs={breadCrumbs} />
        </StyledBreadcrumbsContainer>
        <StyledContentWrapper>
          {blocks?.blocks?.map(
            // TO DO : HOW TO FIND BLOCK TYPE IN GENERATED GRAPHQL TYPES
            (block: any, index: number) => {
              return (
                <BlockRenderer
                  key={index}
                  blockType={block.blockType}
                  blockData={block}
                  components={components}
                  locale={locale}
                  props={{ breadCrumbs }}
                />
              )
            },
          )}
        </StyledContentWrapper>
      </StyledDiv>
    </Container>
  )
}

export default Terms
